import { render, staticRenderFns } from "./sss_chengji.vue?vue&type=template&id=70da0089&scoped=true"
import script from "./sss_chengji.vue?vue&type=script&lang=js"
export * from "./sss_chengji.vue?vue&type=script&lang=js"
import style0 from "./sss_chengji.vue?vue&type=style&index=0&id=70da0089&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70da0089",
  null
  
)

export default component.exports